export const CHECKOUT_URL = 'https://geografiapronta.impultienda.ar/checkout'

/** Ancora della sezione con il riepilogo prezzo e il bottone di acquisto. */
export const OFFER_ANCHOR = '#offerta'
